module.exports = __webpack_public_path__ + "static/img/service_introduce_5766_zh_h5.c667c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5766_zh_h5.png
// module id = Z6qU
// module chunks = 34